import { WorkspaceComment } from "@/models/workspace/WorkspaceComment";

import { FC } from "react";
import { standardHoverFocus, standardStyling } from "./utils/StandardStyles";
import useCommentsStore from "@/stores/comments.store";
import UserAvatar from "@/components/images/UserAvatar";

type CommentProfilePictureProps = {
  comment: WorkspaceComment;
};

const CommentProfilePicture: FC<CommentProfilePictureProps> = ({
  comment,
}: CommentProfilePictureProps) => {
  const {
    getCommentAuthor,
    hoveredThread,
    setHoveredThread,
    expandedReplies,
    toggleReplies,
  } = useCommentsStore();

  const author = getCommentAuthor(comment);

  return (
    <div className="relative">
      <UserAvatar
        user={author}
        avatarClassName="size-8 shrink-0 z-10 relative"
      />

      <div
        className={`${standardStyling} left-4 top-8 transform -translate-x-1/2  ${
          hoveredThread === comment.id
            ? "border-primary"
            : "border-border"
        }
        `}
        style={{
          height:
            comment.replies &&
            comment.replies.length > 0 &&
            !expandedReplies[comment.id]
              ? "calc(96% - 20px)"
              : comment.replies &&
                  comment.replies.length > 0 &&
                  expandedReplies[comment.id]
                ? "calc(100% - 20px)"
                : "0",
          display:
            comment.replies && comment.replies.length > 0 ? "block" : "none",
        }}
        onClick={(e) => {
          e.stopPropagation();
          toggleReplies(comment.id);
        }}
        onMouseEnter={() => setHoveredThread(comment.id)}
        onMouseLeave={() => setHoveredThread(null)}
      >
        <div
          className={standardHoverFocus}
          onClick={(e) => {
            e.stopPropagation();
            toggleReplies(comment.id);
          }}
        />
      </div>

      {comment.replies &&
        comment.replies.length > 0 &&
        expandedReplies[comment.id] && (
          <div
            className={`${standardStyling} left-[15px] -bottom-[26px] w-[32px] h-[22px] ${
              hoveredThread === comment.id
                ? "border-primary"
                : "border-border"
            }`}
            onClick={(e) => {
              e.stopPropagation();
              toggleReplies(comment.id);
            }}
            onMouseEnter={() => setHoveredThread(comment.id)}
            onMouseLeave={() => setHoveredThread(null)}
          >
            <div
              className={standardHoverFocus}
              onClick={(e) => {
                e.stopPropagation();
                toggleReplies(comment.id);
              }}
            />
          </div>
        )}
    </div>
  );
};

export default CommentProfilePicture;
